// The site's own elements. Each starts itself where it stands in a page and loads the data it
// needs; there is no start-up call and no page-wide loading (docs/plan-content-pages.md, step 4).
import { startPageConsole } from './PageConsole'

export { AncientTest } from './AncientArchitecture'
export { PictureCardTest } from './PictureCard'

export { VideoPreview } from 'HtmlTags/VideoPreview'
export { TeaserTabs, TeaserTab } from 'HtmlTags/TeaserTabs'
export { ArchitectureElement } from 'HtmlTags/AncientArchitecture'
export { TeaserTile } from 'HtmlTags/TeaserTile'
export { PictureCard } from 'HtmlTags/PictureCard'
export { ProjectCardList } from 'HtmlTags/ProjectCardList'
export { CourseCardList } from 'HtmlTags/CourseCardList'
export { StaffLocationElement } from 'HtmlTags/StaffLocation'
export { TeamOverviewElement } from 'HtmlTags/TeamOverview'
export { TeachingOverviewElement } from 'HtmlTags/TeachingOverview'
export { ThemeSwitchElement } from 'HtmlTags/ThemeSwitch'

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startPageConsole);
} else {
  startPageConsole();
}
